import React, { useState } from 'react'
import { Form, Formik } from 'formik'
import { Link } from 'react-router-dom'
import { FiSearch, FiArrowLeft, FiEye } from 'react-icons/fi'
import {
    FaUserMd, FaUserGraduate
} from 'react-icons/fa'
import { toast } from 'react-toastify'

import { api } from '~/services/api'

import arrayUtils from '~/util/array'

import Card from '~/components/Card'
import Table from '~/components/Table'
import Spinner from '~/components/Spinner'
import { Textbox, Button } from '~/components/Form'

import {
    Container, CrachaContainer, MedicoContainer, AcademicoContainer
} from './styles'

import defaultAvatar from '~/assets/images/avatar.png'
import logo from '~/assets/images/logo.png'

export default function () {
    const [resultados, setResultados] = useState(null)
    const [associado, setAssociado] = useState(null)
    const [buscando, setBuscando] = useState(false)

    function defineAssociado(assoc) {
        const sindicalizacaoMaisRecente = arrayUtils.get.getLast(assoc.sindicalizacao)

        setAssociado({
            ...assoc,
            data_sindicalizacao: sindicalizacaoMaisRecente?.data
        })
    }

    async function handleSubmit(values) {
        setResultados(null)
        setAssociado(null)
        setBuscando(true)

        try {
            const response = await api.get('consulta_publica', {
                params: values
            })

            setBuscando(false)

            if (response.length === 1) {
                defineAssociado(response[0])
            } else {
                setResultados(response)
            }
        } catch (e) {
            toast.error(e.msg)
        }
    }

    async function handleShowAssociado(item) {
        const response = await api.get(`associado/${item.id}`)

        if (response.status_associacao.id !== 3) {
            toast.warn('Nenhum associado encontrado.')
            return
        }

        defineAssociado(response)
    }

    return (
        <Container>
            {associado ? (
                <>
                    <CrachaContainer>
                        <img src={associado.pessoa.usuario.avatar?.link || defaultAvatar} alt="avatar" className="foto" />

                        <h1>{associado.pessoa.nome}</h1>

                        {associado.medico ? (
                            <MedicoContainer>
                                <>
                                    <h2>
                                        <FaUserMd />
                                        {`Médic${associado.pessoa.sexo === 'M' ? 'o' : 'a'}`}
                                    </h2>

                                    <h2>
                                        {`CRM: ${associado.pessoa.usuario.crm}`}
                                    </h2>

                                    {associado.especialidades.length > 0 && (
                                        <div>
                                            <h2>Especialidade</h2>

                                            {associado.especialidades.map(espec => (
                                                <p key={espec.id}>{`${espec.descricao}${espec.associado_especialidade.codigo_rqe ? ` - ${espec.associado_especialidade.codigo_rqe}` : ''}`}</p>
                                            ))}
                                        </div>
                                    )}
                                </>
                            </MedicoContainer>
                        ) : (
                            <AcademicoContainer>
                                <h2>
                                    <FaUserGraduate size={11} />
                                    {`Acadêmic${associado.pessoa.sexo === 'M' ? 'o' : 'a'}`}
                                    
                                    {associado.aspirante ? (
                                        <span className="badge green">ASPIRANTE</span>
                                    ) : (
                                        <span className="badge warn">NÃO ASPIRANTE</span>
                                    )}
                                </h2>

                                <div>
                                    {associado.dados_academicos && (
                                        <h2>{`Faculdade: ${associado.dados_academicos.faculdade.descricao}`}</h2>
                                    )}
                                </div>
                            </AcademicoContainer>
                        )}
                         
                        {/* <ExtraDataContainer>
                            <FaRegCalendarCheck size={13} />
                            {`Data de associação: ${associado.data_sindicalizacao ? format(new Date(associado.data_sindicalizacao), 'dd/MM/yyyy') : 'Indefinida'}`}
                        </ExtraDataContainer> */}

                        <img src={logo} alt="" className="logo" />
                    </CrachaContainer>

                    <Link to="/consulta_publica" className="button green">
                        Voltar
                        <FiArrowLeft size={24} />
                    </Link>
                </>
            ) : (
                <Card>
                    <h1>Consulta de associados</h1>

                    <Formik
                        onSubmit={handleSubmit}
                        initialValues={{
                            nome: '',
                            identificador: ''
                        }}
                    >
                        {() => (
                            <Form>
                                <Textbox
                                    name="identificador"
                                    label="CRM ou CPF"
                                />

                                <Textbox
                                    name="nome"
                                    label="Nome"
                                />

                                <Button type="submit" className="transparent">
                                    Pesquisar
                                    <FiSearch />
                                </Button>
                            </Form>
                        )}
                    </Formik>

                    {resultados ? (
                        <Table
                            headers={[
                                { name: 'identificador', value: 'CRM / Matrícula de acadêmico', centered: true },
                                { name: 'nome', value: 'Nome' }
                            ]}
                            data={resultados.map(resultado => ({
                                id: resultado.id,
                                identificador: resultado.pessoa.usuario.crm,
                                nome: resultado.pessoa.nome
                            }))}
                            actions={[
                                {
                                    action: item => { handleShowAssociado(item) },
                                    name: 'Mostrar detalhes',
                                    icon: FiEye,
                                    iconSize: 16
                                }
                            ]}
                            emptyLabel="Nenhum associado encontrado"
                        />
                    ) : buscando ? (
                        <Spinner />
                    ) : (
                        <></>
                    )}
                </Card>
            )}
        </Container>
    )
}
